import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CharterPerformancePCComponent } from './charter-performance-pc.component';


const routes: Routes = [
  {
    path: '',
    component: CharterPerformancePCComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CharterPerformancePCRoutingModule {}